import requests from "./httpService";

const AirportPickupBasicRateServices = {
  getAllAirportPickupBasicRate: async (body) => {
    return requests.get(`/airportPickupBasicRate/`);
  },

  addAirportPickupBasicRate: async (body) => {
    return requests.post(`/airportPickupBasicRate/add`, body);
  },
  getAirportPickupBasicRateById: async (id) => {

    return requests.get(`/airportPickupBasicRate/${id}`);
  },

  updateAirportPickupBasicRate: async (id, body) => {
    return requests.put(`/airportPickupBasicRate/update/${id}`, body);
  },

  deleteAirportPickupBasicRate: async (id) => {
    return requests.delete(`/airportPickupBasicRate/delete/${id}`);
  },

  updateAirportPickupStatus: async (id, body) => {
    return requests.post(`/airportPickupBasicRate/update-status/${id}`, body);
  }
};

export default AirportPickupBasicRateServices;
